import {useEffect, useState} from "@wordpress/element";

const settings = window?.wc?.wcSettings?.getSetting( 'acceptblue-ach_data', {} );
const label = window?.wp?.htmlEntities?.decodeEntities( settings.title ) || window?.wp?.i18n.__( 'ACH/Check', 'acceptblue-ach' );

const ACHForm = function (props){
    const [routingValue, setRoutingValue] = useState('');
    const [accountValue, setAccountValue] = useState('');
    const [hasErrors, setHasErrors] = useState(false);
    const [globalError, setGlobalError] = useState('');
    const [footerComponents, setFooterComponents] = useState([]);
    const [headerComponents, setHeaderComponents] = useState([]);

    const { eventRegistration, emitResponse } = props;
    const { onPaymentSetup, onCheckoutValidation } = eventRegistration;

    const isEmpty = (value) => {
        if(typeof value !== "string") return true;
        return value.trim().length === 0;
    }

    useEffect(() => {
        const unsubscribe = onCheckoutValidation(async function(){
            if(isEmpty(routingValue) || isEmpty(accountValue)){
                setGlobalError('Error. All fields in ACH/Check form is required.');
                setHasErrors(true);
            }
            if(!isEmpty(routingValue) && !isEmpty(accountValue)){
                setGlobalError('');
                setHasErrors(false);
            }
        });

        return () => unsubscribe;
    }, [routingValue, accountValue]);

    useEffect( () => {
        const unsubscribe = onPaymentSetup( async function () {
            if ( !hasErrors ) {
                return {
                    type: emitResponse.responseTypes.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            'routing-number': routingValue,
                            'account-number': accountValue
                        },
                    },
                };
            }

            return {
                type: emitResponse.responseTypes.ERROR,
                message: globalError,
            };
        } );

        return () => unsubscribe();
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onPaymentSetup,routingValue, accountValue, hasErrors, globalError
    ]);

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('pgabfw-renderFooterComponentsACH', {
            detail: {
                setComponent: component => setFooterComponents([ ...footerComponents, component ])
            }
        }));
        window.dispatchEvent(new CustomEvent('pgabfw-renderHeaderComponentsACH', {
            detail: {
                setComponent: component => setHeaderComponents([ ...headerComponents, component ])
            }
        }));
    }, []);

    function onRoutingChange(routing){
        setRoutingValue(routing.target.value);
    }

    function onAccountChange(account) {
        setAccountValue(account.target.value);
    }

    return (
        <div className="acceptblue-ach-wrap">
            {headerComponents.map( component => component )}
            <div className="ab-routing-number-wrap">
                <label htmlFor="ab-routing-num">Routing Number</label><br/>
                <input type="text" name="routing-number" placeholder="" onChange={onRoutingChange} value={routingValue} id="ab-routing-num" />
            </div>
            <div className="ab-account-number-wrap">
                <label htmlFor="ab-account-num">Account Number</label><br/>
                <input type="text" name="account-number" placeholder="" onChange={onAccountChange} value={accountValue} id="ab-account-num" />
            </div>
            {footerComponents.map( component => component )}
        </div>
    )
}

const AcceptBlueACH = {
    name: 'acceptblue-ach',
    label: label,
    content: <ACHForm/>,
    edit: <ACHForm/>,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};

window.wc.wcBlocksRegistry.registerPaymentMethod(AcceptBlueACH);